/**
 * Localstorage of search parameters
 */

import { logger, dQS } from "./utils.js";
import { set_datepicker_dates } from "./calendar.js";

declare const LONGRENT: boolean;

/** Localstorage of user dates. */
function checkStoredDates() {

  // Ignore below: Set dates always to blank on reload: 
  (<HTMLSelectElement>dQS("#hora_salida")).value = "-";
  (<HTMLSelectElement>dQS("#hora_vuelta")).value = "-";
  (<HTMLInputElement>dQS("#fecha_salida")).value = "";
  (<HTMLInputElement>dQS("#fecha_vuelta")).value = "";


  /*
  logger("Check Dates");
  // Check formats are correct:
  let now = new Date;

  let correctDateFormat = false;
  
  const re = new RegExp(/^(\d{4})(\-)(\d{2})(\-)(\d{2})$/);

  if (typeof Storage !== undefined) {

    if (localStorage.fecha_ts
      && re.test(localStorage.fecha_salida)
      && re.test(localStorage.fecha_vuelta)) {

      correctDateFormat = true;

    }
  }

   // expired check against 2 hours store dates

  if (correctDateFormat) {

    const lsts = now.getTime() - 1e3 * 60 * 60 * 2;

    if (parseInt(localStorage.fecha_ts) < lsts) {
     
      logger("stored dates are stale", "warn");
      correctDateFormat = false;

    }

  }


  // Ignore below: Set dates always to blank on reload: 

  // Preset to 1 day rental, 1 dy from now: 
  if (!correctDateFormat) {

    logger("Store dates invalid", "log");
    
    let fd = new Date( now.getTime() + 1e3 * 60 * 60 * 24 * 1 );

    let duration = (LONGRENT) ? 30 : 1;

    const td = new Date(fd.getTime() + 1e3 * 60 * 60 * 24 * duration);

    const from_date = fd.getFullYear() + "-" +
      ("0" + (fd.getMonth() + 1)).slice(-2) + "-" +
      ("0" + fd.getDate()).slice(-2);

    const to_date = td.getFullYear() + "-" +
      ("0" + (td.getMonth() + 1)).slice(-2) + "-" +
      ("0" + td.getDate()).slice(-2);


    const nodes = ["fecha_ts", "hora_salida", "hora_vuelta", "fecha_salida", "fecha_vuelta"];

    nodes.forEach((n) => {
      localStorage.removeItem(n);
    });

    (<HTMLSelectElement>dQS("#hora_salida")).value = "10:30";
    (<HTMLSelectElement>dQS("#hora_vuelta")).value = "10:30";
    (<HTMLInputElement>dQS("#fecha_salida")).value = from_date;
    (<HTMLInputElement>dQS("#fecha_vuelta")).value = to_date;

    set_datepicker_dates(fd, td);

  } else {

    logger("Store dates valid", "log");

    (<HTMLSelectElement>dQS("#hora_salida")).value = localStorage.hora_salida;
    (<HTMLSelectElement>dQS("#hora_vuelta")).value = localStorage.hora_vuelta;
    (<HTMLInputElement>dQS("#fecha_salida")).value = localStorage.fecha_salida;
    (<HTMLInputElement>dQS("#fecha_vuelta")).value = localStorage.fecha_vuelta;

    set_datepicker_dates(new Date(localStorage.fecha_salida), new Date(localStorage.fecha_vuelta));

  }

*/
 

}


/** set consistent dates between pages (user comfort) */
function saveStoredDates(fd:string, fh:string, td:string, th:string) {

  logger("Save Dates");

  if (typeof Storage !== "undefined") {

    const d = new Date;
    const lsts = d.getTime();

    localStorage.setItem("fecha_ts", lsts.toString());
    localStorage.setItem("fecha_salida", fd);
    localStorage.setItem("fecha_vuelta", td);
    localStorage.setItem("hora_salida", fh);
    localStorage.setItem("hora_vuelta", th);

  }
}


function updateSearchFormVars(){

  logger("Update search form vars");

  const fd = (<HTMLInputElement>dQS("#fecha_salida")).value;
  const td = (<HTMLInputElement>dQS("#fecha_vuelta")).value;
  const fh = (<HTMLSelectElement>dQS("#hora_salida")).value;
  const th = (<HTMLSelectElement>dQS("#hora_vuelta")).value;

  saveStoredDates(fd, fh, td, th);
  
}

export { checkStoredDates, saveStoredDates, updateSearchFormVars };